import classNames from 'classnames';
import React from 'react';
import onClickOutside from 'react-onclickoutside';

import CalendarActions from './child-components/CalendarActions';
import CalendarTable from './child-components/CalendarTable';
import CalendarToolbar from './child-components/CalendarToolbar';

const Calendar = ({
    className,
    pickingEnd,
    togglePickingEnd,
    current,
    prevMonth,
    nextMonth,
    arrival,
    departure,
    setArrival,
    setDeparture,
    closeCalendar,
}) => {
    Calendar.handleClickOutside = () => {
        closeCalendar();
    };

    return (
        <div className={className}>
            <div
                className={classNames({
                    'datepicker-popover': true,
                    to: pickingEnd,
                    from: !pickingEnd,
                })}
            >
                <CalendarToolbar
                    current={current}
                    prevMonth={prevMonth}
                    nextMonth={nextMonth}
                />
                <CalendarTable
                    current={current}
                    start={arrival}
                    end={departure}
                    setArrival={setArrival}
                    setDeparture={setDeparture}
                    togglePickingEnd={togglePickingEnd}
                    pickingEnd={pickingEnd}
                    closeCalendar={closeCalendar}
                />
                <CalendarActions
                    arrival={arrival}
                    departure={departure}
                    setDeparture={setDeparture}
                    closeCalendar={closeCalendar}
                />
            </div>
        </div>
    );
};
Calendar.prototype = {};

const handleClickOutside = () => Calendar.handleClickOutside;

const clickOutsideConfig = { handleClickOutside };

export default onClickOutside(Calendar, clickOutsideConfig);
